// extracted by mini-css-extract-plugin
export default {"body":"body_body__iRBJp","body_top":"body_body_top__zY2k7","body_bottom":"body_body_bottom__gDCqU"};